<template>
  <div
    class="w-full hidden lg:flex items-center justify-between self-stretch px-6 py-1 h-12 bg-surface rounded-lg border border-border"
  >
    <div class="flex items-center gap-1">
      <div class="w-6 h-6 bg-skeleton rounded-full animate-pulse"></div>
      <div class="w-8 h-4 bg-skeleton rounded animate-pulse"></div>
    </div>

    <div class="flex items-center justify-center">
      <div class="w-24 h-4 bg-skeleton rounded animate-pulse"></div>
    </div>

    <div class="flex items-center gap-1">
      <div class="w-6 h-6 bg-skeleton rounded-full animate-pulse"></div>
      <div class="w-8 h-4 bg-skeleton rounded animate-pulse"></div>
    </div>
  </div>
</template>

<script setup lang="ts"></script>
